import type { UserRole } from "@/contexts/AuthContext";
import { roleHomePath } from "@/contexts/AuthContext";

export function canAccessPath(role: UserRole, path: string): boolean {
  if (!role || !path) return false;
  const clean = path.split("?")[0] || path;

  switch (role) {
    case "admin":
      return clean.startsWith("/admin");
    case "store":
      return clean.startsWith("/store");
    case "distributor":
      return clean.startsWith("/distributor");
    case "wholesaler":
      return clean.startsWith("/wholesaler");
    case "delivery":
      return clean.startsWith("/delivery");
    case "customer":
      return (
        clean.startsWith("/account") ||
        clean.startsWith("/checkout") ||
        (!clean.startsWith("/admin") &&
          !clean.startsWith("/store") &&
          !clean.startsWith("/distributor") &&
          !clean.startsWith("/wholesaler") &&
          !clean.startsWith("/delivery") &&
          !clean.startsWith("/auth"))
      );
    default:
      return false;
  }
}

/** Prefer callback URL after login when the role can access it. */
export function resolvePostLoginPath(
  role: UserRole,
  returnTo?: string | null,
): string {
  const home = roleHomePath(role);
  if (!returnTo) return home;

  const path = returnTo.trim();
  if (!path || path.startsWith("/auth")) return home;
  if (!canAccessPath(role, path)) return home;
  return path;
}

export function buildLoginPath(
  loginBase: string,
  returnTo?: string | null,
): string {
  if (!returnTo || returnTo.startsWith("/auth")) return loginBase;
  const url = new URL(loginBase, "http://local");
  url.searchParams.set("returnUrl", returnTo);
  return `${url.pathname}${url.search}`;
}
